import { render } from "./CadastroCarro.vue?vue&type=template&id=f8ab1bb2"
import script from "./CadastroCarro.vue?vue&type=script&lang=js"
export * from "./CadastroCarro.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__